import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useNotification from 'hooks/useNotification';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import SimpleRadioGroupField from 'components/ui/simple-fields/radio-group/SimpleRadioGroupField';
import EskizSettings from './EskizSettings';
import TextupSettings from './TextupSettings';

const PROVIDER_OPTIONS = [
  { code: 'eskiz', label: 'settings.sms.provider.eskiz' },
  { code: 'textup', label: 'settings.sms.provider.textup' },
];

const System = () => {
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  const sendNotification = useNotification();
  // Server javob bermaguncha hech narsani render qilmaymiz — aks holda
  // 'eskiz' formasi bir lahza chaqib, keyin 'textup'ga almashib qolishi mumkin
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axiosPrivate
      .get('/admin/sms/provider')
      .then((res) => {
        if (cancelled) return;
        setProvider(res?.data?.data?.provider || 'eskiz');
      })
      .catch(() => {
        if (!cancelled) setProvider('eskiz');
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeProvider = async (value) => {
    const prev = provider;
    setProvider(value); // darhol ko'rsatamiz, so'rov orqa fonda ketadi
    try {
      await axiosPrivate.post('/admin/sms/provider', { provider: value });
      sendNotification({
        msg: t('settings.sms.provider.success'),
        variant: 'success',
      });
    } catch (error) {
      setProvider(prev); // saqlanmasa — eski tanlovga qaytaramiz
      sendNotification({
        msg: error?.response?.data?.message || error?.message,
        variant: 'error',
      });
    }
  };

  return (
    <div>
      <div className='w-96 px-5 py-3 my-shadow-1 rounded-lg mb-3'>
        <SimpleRadioGroupField
          label={t('settings.sms.provider.title')}
          name='sms-provider'
          value={provider || 'eskiz'}
          options={PROVIDER_OPTIONS}
          changeFn={handleChangeProvider}
        />
      </div>

      {provider === 'textup' ? <TextupSettings /> : provider === 'eskiz' ? <EskizSettings /> : null}
    </div>
  );
};

export default memo(System);
